module.exports = __webpack_public_path__ + "static/media/domain_logo_Brazil.c51d24f2.svg";